// extracted by mini-css-extract-plugin
export var footer = "_no-5";
export var fulfillmentInput = "_no-0";
export var shipDateInput = "_no-1";
export var shipmentModal = "_no-2";
export var shipmentModalContent = "_no-3";
export var tableContainer = "_no-4";